<template>
  <div class="k-dropdown" 
       :class="{'k-dropdown--header-big': big, 
                'k-dropdown--content-above': above, 
                'k-dropdown--display-right': right, 
                'k-dropdown--with-image': image }" 
       v-on-clickaway="away">
    <div class="k-dropdown__header" :class="{ 'k-dropdown__header--active': click }" @click="toggleDropdown">
      <div>
        <slot name="title"></slot>
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </div>
      <div class="k-dropdown__image" v-if="image">
        <slot name="image"></slot>
      </div>
    </div>
    
    <div class="k-dropdown__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],
  props: {
    dataBig: {
      type: Boolean,
      required: false
    },
    displayAbove: {
      type: Boolean,
      required: false
    },
    displayRight: {
      type: Boolean,
      required: false
    },
    dataImage: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      click: false,
      big: this.dataBig,
      above: this.displayAbove,
      right: this.displayRight,
      image: this.dataImage
    }
  },
  methods: {
    toggleDropdown () {
      this.click = !this.click
    },
    away () {
      if (this.click) {
        this.click = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/Dropdown.vue